import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import RbUploadSuccessModalComponent from '../components/rb-upload-success-modal/rb-upload-success-modal.jsx';

import {
    closeUploadSuccess
} from '../reducers/modals';

// import {
//     closeHelpMenu
// } from '../reducers/menus';

class RbUploadingModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleCancel'
        ]);
    }

    handleCancel (e) {
        e.stopPropagation();
        this.props.onClose();
    }

    render () {
        return (
            <RbUploadSuccessModalComponent
                onCancel={this.handleCancel}
            />
        );
    }
}

RbUploadingModal.propTypes = {
    onClose: PropTypes.func
};

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({
    onClose: () => {
        dispatch(closeUploadSuccess());
        // dispatch(closeHelpMenu());
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RbUploadingModal);
